'use strict';
(function () {
  angular.module('pentaApp').factory('posTable.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/posTable');
  }
})();
